import { Text } from '@/components/ui/text'
import { api } from '@api'
import { useQuery } from '@tanstack/solid-query'
import { Bookmark } from 'lucide-solid'
import { Show } from 'solid-js'
import { Flex } from 'styled-system/jsx'

async function fetchCommanderScore(setupId: string): Promise<number | null> {
  const { data: commanders, error: commandersErr } = await api()
    .from('profile_private')
    .select('id')
    .eq('role', 'commander')

  if (commandersErr) throw commandersErr

  const commanderIds = (commanders ?? []).map((r) => r.id)
  if (!commanderIds.length) {
    // nothing to fetch
    return null
  }

  const { data, error } = await api()
    .from('taken_setups')
    .select('score', { head: false })
    .eq('setup_id', setupId)
    .in('user_id', commanderIds)

  return data && data.reduce((s, r) => s + (r.score ?? 0), 0) / data.length
}

export const CommanderScore = (props: { setupId?: string }) => {
  const q = useQuery(() => ({
    queryKey: ['commader-score-count', props.setupId],
    queryFn: () => fetchCommanderScore(props.setupId || ''), // Safely handle TS error
    enabled: !!props.setupId,
    staleTime: 30 * 60 * 1000, // 30m cache freshness
    gcTime: 30 * 60 * 1000, // 30m cache retention
    retry: 1,
    placeholderData: 0,
  }))

  return (
    <Show
      when={!q.isLoading && q.data && q.data > 0}
      fallback={<Text fontSize='13.5px' fontWeight='700' color='editorialInk3'>-</Text>}
    >
      <Flex alignItems='center' gap='6px'>
        <Bookmark width={11} height={14} fill='var(--colors-editorial-accent-deep)' stroke='var(--colors-editorial-accent-deep)' />
        <Text fontSize='13.5px' fontWeight='700' color='editorialAccentDeep'>PHQ {q.data}</Text>
      </Flex>
    </Show>
  )
}
